export type BotChannel = 'telegram' | 'whatsapp';

export interface ChannelConnection {
  channel: BotChannel;
  connected: boolean;
  linkedAt: string | null;
}

// Channels we render, in display order.
export const BOT_CHANNELS: BotChannel[] = ['telegram', 'whatsapp'];

// Map the /v1/link/connection response into an ordered list of connected
// channels only. Unknown/missing channels are treated as disconnected.
// Fail-closed: a malformed payload yields an empty list (never a stale row).
export function parseConnections(data: unknown): ChannelConnection[] {
  const obj = data && typeof data === 'object' ? (data as Record<string, any>) : {};
  return BOT_CHANNELS
    .map((channel) => ({
      channel,
      connected: !!obj[channel]?.connected,
      linkedAt: obj[channel]?.linked_at ?? null,
    }))
    .filter((c) => c.connected);
}
